"use client";

import Prism from "prismjs";
import { useEffect, useRef } from "react";
import "prismjs/themes/prism.css";

export const CodeHighlighter = ({
	children,
	className,
}: { children: React.ReactNode; className?: string }) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		Prism.highlightAllUnder(containerRef.current!);
	}, []);

	return (
		<div ref={containerRef} className={className}>
			{children}
		</div>
	);
};
